/**
 * Admin Layout Component
 * community 스타일 레이아웃 (NavigationBar + Sidebar)
 */

import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import NavigationBar from '../shared/NavigationBar';
import Sidebar from './Sidebar';

const Layout = ({ badges = {} }) => {
  const location = useLocation();
  const { user } = useAuth();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // 모바일 메뉴 토글
  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);
  const closeMobileMenu = () => setMobileMenuOpen(false);

  // 라우트 변경 시 모바일 메뉴 닫기
  useEffect(() => {
    closeMobileMenu();
  }, [location.pathname]);

  // 모바일 메뉴 열릴 때 배경 스크롤 방지
  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileMenuOpen]);

  // 현재 활성 섹션 결정
  const getActiveSection = () => {
    const path = location.pathname;
    if (path === '/') return 'dashboard';
    if (path.includes('/users')) return 'users';
    if (path.includes('/reports')) return 'reports';
    if (path.includes('/projects')) return 'projects';
    if (path.includes('/api')) return 'api';
    if (path.includes('/server')) return 'server';
    return 'dashboard';
  };

  // 모바일 헤더
  const MobileHeader = () => (
    <div className="hidden md:hidden flex items-center gap-3 px-4 py-3 bg-white border-b border-gray-200 sticky top-[44px] z-50 max-md:flex">
      <button
        className="flex flex-col justify-center items-center gap-[5px] w-9 h-9 bg-transparent border-none cursor-pointer p-2 rounded-lg transition-colors hover:bg-gray-100"
        onClick={toggleMobileMenu}
        aria-label="메뉴 열기"
      >
        <span className="block w-[18px] h-0.5 bg-gray-900 rounded-sm transition-all"></span>
        <span className="block w-[18px] h-0.5 bg-gray-900 rounded-sm transition-all"></span>
        <span className="block w-[18px] h-0.5 bg-gray-900 rounded-sm transition-all"></span>
      </button>
      <span className="text-[15px] font-semibold text-gray-900">Admin</span>
    </div>
  );

  return (
    <>
      <NavigationBar />

      <div className="flex min-h-[calc(100vh-44px)] pt-[44px] bg-gray-50">
        {/* 모바일 오버레이 */}
        {mobileMenuOpen && (
          <div
            className="fixed top-[44px] left-0 right-0 bottom-0 bg-black/40 z-[99] animate-fadeIn"
            onClick={closeMobileMenu}
          />
        )}

        <Sidebar
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
          activeSection={getActiveSection()}
          mobileOpen={mobileMenuOpen}
          onMobileClose={closeMobileMenu}
          badges={badges}
        />

        <main className="flex-1 min-h-[calc(100vh-44px)] flex flex-col overflow-x-hidden">
          <MobileHeader />
          <div className="flex-1 p-6 md:p-8 lg:p-8 xl:p-12 bg-white min-h-full max-md:p-4">
            <Outlet />
          </div>
        </main>
      </div>
    </>
  );
};

export default Layout;
